/**
 * 异步加载高德地图
 *
 * @export
 * @param {*} key 高德地图key
 * @param {*} plugins 高德地图插件
 * @param {string} [v='2.0'] 高德地图版本
 * @returns
 */

const v = "1.4.15";
const key = "ce44a15b8d36b92726fbcf3f351d01bb";
const plugins = [
    "ElasticMarker",
    "AMap.MouseTool",
    "AMap.PolyEditor",
    "AMap.MarkerClusterer",
    "AMap.RangingTool",
    "AMap.DistrictSearch",
    "AMap.OverView",
    "AMap.DistrictLayer",
    "AMap.CustomLayer",
    "AMap.PlaceSearch"
];

export default function mapLoader() {
    if ((window as any).AMap) { // 已经加载成功，不重复加载
        return new Promise((resolve) => {
            resolve((window as any).AMap)
        })
    }
    const loadMap = new Promise(function(resolve, reject) {
        (window as any).init = function() {
            resolve(AMap)
        };
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = `//webapi.amap.com/maps?v=${v}&key=${key}&plugin=${plugins}&callback=init`;
        script.onerror = reject;
        document.head.appendChild(script);
    });
    const loadMapUI = new Promise(function(resolve, reject) {
        let script2 = document.createElement("script");
        script2.type = "text/javascript";
        script2.async = true;
        script2.src = "//webapi.amap.com/ui/1.0/main-async.js";
        script2.onerror = reject;
        script2.onload = function() {
            //onload必须写在最后
            resolve('success')
        };
        document.head.appendChild(script2);
    });

    return Promise.all([loadMap, loadMapUI])
        .then(function(result) {
            return result[0]
        }).catch(e => {
            console.log(e);
        })
};